import React from 'react';
import playStory from '../../assets/images/app/playstore.png';
import apple from '../../assets/images/app/apple.png';
import mobileView from '../../assets/images/app/mobile-view.png';
const AppDownloadSection = () => {
  return (
    <section className="app-section bg-theme">
      <div className="container">
        <div className="section-wrapper padding-tb">
          <div className="app-content">
            <h4>حمل تطبيق زواجك مبارك</h4>
            <h2>الأسهل لايجاد شريك حياتك</h2>
            <p>
              خدمة الزواج الإسلامي و هي ميزة يتيحها لك التطبيق لإيجاد شريك حياتك المناسب على اعتبار أنك جاد في السعي الشرعي
              للزواج حيث أن التطبيق خاضع لرقابة دينية و قانونية
            </p>
            <ul className="app-download d-flex flex-wrap">
              <li>
                <a href="#" className="d-flex flex-wrap align-items-center">
                  <div className="app-thumb">
                    <img src={playStory} alt="playstore" />
                  </div>
                  <div className="app-content">
                    <p>Available on the</p>
                    <h4>Google Play</h4>
                  </div>
                </a>
              </li>

              <li className="d-inline-block">
                <a href="#" className="d-flex flex-wrap align-items-center">
                  <div className="app-thumb">
                    <img src={apple} alt="apple" />
                  </div>
                  <div className="app-content">
                    <p>Available on the</p>
                    <h4>App Store</h4>
                  </div>
                </a>
              </li>
            </ul>
          </div>
          <div className="mobile-app">
            <img src={mobileView} alt="mbl-view" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default AppDownloadSection;